/**
 * Given a string like: `Troop 0015` it returns `Troop 15`
 */
export default function removeLeadingZeros(str: string) {
  return (str || '').replace(/\b0+/g, '');
}
